import React, { FC } from 'react';
import { useObserver } from 'mobx-react-lite';
import { useTranslation} from 'react-i18next';
import Button from 'react-bootstrap/Button';
import { saveStepAndGoToCustomizeErSocialLink } from '../order-selection/common-er/custom-kit/CustomizeRedirector';
import { useRootStore } from '../root/RootStoreHooks';

export interface SocialLinkCustomiseButtonProps {
  isMeoMarket: boolean;
}
export const SocialLinkCustomiseButton : FC<SocialLinkCustomiseButtonProps> = ({isMeoMarket}) => {
  const { t } = useTranslation();
  const store = useRootStore();

  function handleClick() {
    saveStepAndGoToCustomizeErSocialLink(store);
  }

  return useObserver(() => (
    <>
      <div className="d-flex flex-row flex-column">
            <Button variant="primary" onClick={() => handleClick()}>
             {isMeoMarket? <>{t('CustomizeAutoship')}</>: <>{t('OptionalAddAdditionalProducts')}</>}
            </Button>
          </div>
    </>
  ));
};
